
if (typeof window !== "undefined") {
  function load() {
    const style = document.createElement("style");
    style.textContent = `  body {
        width: 100%;
        height: 100vh;
        margin: 0;
        padding: 0;
      }
      *{
        box-sizing: border-box;
        padding: 0;
        margin: 0;
      }
      .chat-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
      .chat-iframe {
        width: 100%;
        height: 100%;
        border: none;
      }
      
      #widget.fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100% !important;
        max-height: 100%;
        border-radius: 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        z-index: 1000;
      }
      
      #widget.fullscreen.minimized {
        height: 0 !important;
      }
      #widget.minimized {
       height: 0 !important;
      }
      #widget-controls {
        display: flex;
      }
      
      #widget {
        max-height: 800px;
      }
      
      @media (min-width: 768px) {
        #widget {
          height: 80% !important;
        }
      }`;
      document.head.appendChild(style);
      if (typeof window === "undefined") return;
      if (document.getElementById('widget')) return;
  
    
      let lang = 'ka';
  
      if (typeof window !== 'undefined') {
        const storedLang = localStorage.getItem('lang');
      
        if (storedLang === 'ge') {
          lang = 'ka';
        } else if (storedLang) {
          lang = storedLang;
        }
      }
      
      let iframeToken = "";
    
      function setLang(newLang) {
        lang = newLang;
        localStorage.setItem("lang", newLang);
        console.log("Language updated to:", newLang);
      }
    
      window.addEventListener("message", (event) => {
        if (event.data.type === "languageUpdate") {
          const newLang = event.data.lang;
          setLang(newLang);
        }
      });
      
      function waitForAuth(maxRetries = 20, interval = 300) {
        return new Promise((resolve, reject) => {
          let retries = 0;
      
          const check = () => {
            const loggedIn = localStorage.getItem("loggedIn");
            const act = localStorage.getItem("act");
            const rft = localStorage.getItem("rft");
      
            if (loggedIn === "true" && act && rft) {
              resolve({ act, rft });
            } else {
              retries++;
              if (retries >= maxRetries) {
                reject("❌ Token or login status not ready in time");
              } else {
                setTimeout(check, interval);
              }
            }
          };
      
          check();
        });
      }
      
      window.waitForAuth = waitForAuth;
      
      
      waitForAuth()
      .then(({ act, rft }) => {
        return fetch("https://imedil-ai.ekimo.ge/api/ka/auth", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token: act, refresh_token: rft }),
        });
      })
      .then((res) => {
        if (!res.ok) throw new Error("❌ Token fetch failed");
        return res.json();
      })
      .then((data) => {
        const iframe = document.getElementById("widget-iframe");
        if (iframe && iframe.contentWindow && data?.data?.token) {
          iframe.contentWindow.postMessage({ token: data.data.token }, "*");
          console.log("✅ Token sent to iframe:", data.data.token);
        } else {
          console.warn("⚠️ iframe not ready or token missing");
        }
      })
      .catch((err) => {
        console.error("🚨 Error during token flow:", err);
      });
    
      window.addEventListener("storage", (e) => {
        if (e.key === "act" || e.key === "rft") {
          sendTokenToIframe();
        }
      });
            
      function sendTokenToIframe(token) {
        const iframe = document.getElementById('widget-iframe');
      
        if (iframe) {
          if (iframe.contentWindow && iframe.complete) {
            iframe.contentWindow.postMessage({ token }, "*");
          } else {

            iframe.addEventListener("load", () => {
              iframe.contentWindow.postMessage({ token }, "*");
            });
          }
        }
      }
      
      if (
        localStorage.getItem("act") &&
        localStorage.getItem("rft")
      ) {
        sendTokenToIframe();
      }
      
    
    
      if (document.getElementById("widget")) {
        return; 
      }
      const createWidget = () => {
        // Create the widget container
        const widget = document.createElement('div');
        widget.id = 'widget';
        widget.style.cssText = `
          position: fixed;
          bottom: 10px;
          right: 20px;
          width: ${window.innerWidth <= 1024 ? 'calc(100% - 40px)' : '450px'};
          height: ${window.innerWidth <= 1024 ? '90%' : '90%'};
          border-radius: 36px;
          display: flex;
          flex-direction: column;
          z-index: 1000;
          overflow: hidden;
        `;
    
        // Create the header
        const header = document.createElement('div');
        header.id = 'widget-header';
        header.style.cssText = `
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
          padding: 16px;
          background: #142953;
          height: 60px;
        `;
    
        // Add logo to the header
        const logo = document.createElement('img');
        logo.src = 'https://imedil-ai.ekimo.ge/icon/ekimo-ai-logo.svg';
        logo.alt = 'Ekimo AI Logo';
        logo.style.cssText = `
          height: 40px;
          width: 200px;
        `;
        header.appendChild(logo);
    
        // Create control buttons
        const controls = document.createElement('div');
        controls.id = 'widget-controls';
    
        const minimizeButton = document.createElement('button');
        minimizeButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M26 14L14 26M14 14L26 26" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
        minimizeButton.style.cssText = `
          background: none;
          display:flex;
          border: none;
          color: #fff;
          font-size: 16px;
          cursor: pointer;
          margin-left: 8px;
        `;
        controls.appendChild(minimizeButton);
    
        const fullscreenButton = document.createElement('button');
        fullscreenButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M23.5 13H27M27 13V16.5M27 13L21.75 18.25M16.5 27H13M13 27V23.5M13 27L18.25 21.75M23.5 27H27M27 27V23.5M27 27L21.75 21.75M16.5 13H13M13 13V16.5M13 13L18.25 18.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
        fullscreenButton.style.cssText = minimizeButton.style.cssText;
        controls.appendChild(fullscreenButton);
    
        header.appendChild(controls);
    
        // Create the content area
        const content = document.createElement('div');
        content.id = 'widget-content';
        content.style.cssText = `
          flex: 1;
          display: flex;
        `;
        
        const iframe = document.createElement('iframe');
        iframe.id = 'widget-iframe';
        iframe.src =
        `https://imedil-ai.ekimo.ge/${lang}`;
        iframe.style.cssText = `
          width: 100%;
          height: 100%;
          border: none;
        `;
        content.appendChild(iframe);
    
        // Append header and content to the widget
        widget.appendChild(header);
        widget.appendChild(content);
    
        
        // Add widget to the body
        document.body.appendChild(widget);
    
        const expandWidget = () => {
          localStorage.setItem('widgetMinimized', 'false');
          widget.style.height = `${window.innerWidth <= 1024 ? '90%' : '90%'}`;
          content.style.display = 'flex';
          header.style.display = 'flex';
          minimizeButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M26 14L14 26M14 14L26 26" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
          widget.classList.remove('minimized');
        };
    
        const minimizeWidget = () => {
          localStorage.setItem('widgetMinimized', 'true');
          widget.style.height = '40px';
          content.style.display = 'none';
          header.style.display = 'none';
    
          // Replace widget with image
          const icon = document.createElement('img');
          icon.src = 'https://imedil-ai.ekimo.ge/icon/widget-logo.svg';
          icon.alt = 'Widget Icon';
          icon.style.cssText = `
              width: 71px;
              height: 71px;
              cursor: pointer;
              position: fixed;
              right: 27px;
              bottom: 10px;
            `;
          widget.appendChild(icon);
    
          icon.addEventListener('click', () => {
            localStorage.setItem('widgetMinimized', 'false');
            widget.style.height = `${window.innerWidth <= 1024 ? '90%' : '90%'}`;
            content.style.display = 'flex';
            header.style.display = 'flex';
            minimizeButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M26 14L14 26M14 14L26 26" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
            widget.classList.remove('minimized');
            icon.remove();
          });
    
          widget.classList.add('minimized');
        };
    
        // Minimize functionality
        minimizeButton.addEventListener('click', () => {
          if (localStorage.getItem('widgetMinimized') === 'true') {
            expandWidget();
          } else {
            minimizeWidget();
          }
        });
    
        // Fullscreen functionality
        fullscreenButton.addEventListener('click', () => {
          if (widget.classList.contains('fullscreen')) {
            widget.style.cssText = `
              position: fixed;
              bottom: 10px;
              right: 20px;
              width: ${window.innerWidth <= 1024 ? 'calc(100% - 40px)' : '450px'};
              height: ${window.innerWidth <= 1024 ? '90%' : '90%'};
              border-radius: 36px;
              display: flex;
              flex-direction: column;
              z-index: 1000;
              overflow: hidden;
            `;
            fullscreenButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M23.5 13H27M27 13V16.5M27 13L21.75 18.25M16.5 27H13M13 27V23.5M13 27L18.25 21.75M23.5 27H27M27 27V23.5M27 27L21.75 21.75M16.5 13H13M13 13V16.5M13 13L18.25 18.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
            widget.classList.remove('fullscreen');
          } else {
            widget.style.cssText = `
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              background-color: #fff;
              border: none;
              border-radius: 0;
              display: flex;
              flex-direction: column;
              z-index: 1000;
            `;
            fullscreenButton.innerHTML = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="white" fill-opacity="0.2"/>
    <path d="M23.5 13H27M27 13V16.5M27 13L21.75 18.25M16.5 27H13M13 27V23.5M13 27L18.25 21.75M23.5 27H27M27 27V23.5M27 27L21.75 21.75M16.5 13H13M13 13V16.5M13 13L18.25 18.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
            widget.classList.add('fullscreen');
          }
        });
    
        if (
          localStorage.getItem('widgetMinimized') === 'true' ||
          localStorage.getItem('widgetMinimized') == undefined
        ) {
          minimizeWidget();
        } else {
          expandWidget();
        }
      };
    
      createWidget();
      
    
    }
    let currentPath = location.pathname;

    const observer = new MutationObserver(() => {
      if (location.pathname !== currentPath) {
        currentPath = location.pathname;
        // console.log("📦 Route changed to 1:", currentPath);
    

        let storedLang = localStorage.getItem("lang") || "ka";
        let newLang = storedLang === "ge" ? "ka" : storedLang;
        // console.log("📦 Language changed to 2:", newLang);

        const iframe = document.getElementById("widget-iframe");
        if (iframe) {
          const newSrc = `https://imedil-ai.ekimo.ge/${newLang}`;
          if (iframe.src !== newSrc) {
            iframe.src = newSrc;
            // console.log("🔁 iframe.src updated to", newSrc);
          }
        }
    
        // ფუნქციის გამოძახება, თუ არსებობს
        if (typeof window.refreshWidgetVisibility === "function") {
          window.refreshWidgetVisibility();
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    
    
    function removeWidget() {
      const widget = document.getElementById("widget");
      if (widget) {
        widget.style.display = "none";
        console.log("Widget hidden");
       
      }
      const iframe = document.getElementById("widget-iframe");
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ type: "logout" }, "*");
      }
    }
    function showWidget() {
      const widget = document.getElementById("widget");
    
      if (widget) {
        widget.style.display = "flex";
        console.log("Widget shown");
      } else {
        load(); // თუ ჯერ არ არსებობს, თავიდან გაუშვი
      }
    
      // ტოკენის ავტორიზაცია iframe-ში
      waitForAuth()
        .then(({ act, rft }) => {
          return fetch("https://imedil-ai.ekimo.ge/api/ka/auth", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token: act, refresh_token: rft }),
          });
        })
        .then((res) => {
          if (!res.ok) throw new Error("❌ Token fetch failed");
          return res.json();
        })
        .then((data) => {
          const iframe = document.getElementById("widget-iframe");
          if (iframe && iframe.contentWindow && data?.data?.token) {
            iframe.contentWindow.postMessage({ token: data.data.token }, "*");
            console.log("✅ Token resent to iframe:", data.data.token);
          } else {
            console.warn("⚠️ iframe not ready or token missing (showWidget)");
          }
        })
        .catch((err) => {
          console.error("🚨 Error during token resend:", err);
        });
    }
    
    
    function checkLoginStatus() {
      const status = localStorage.getItem("loggedIn");
      const widgetExists = document.getElementById("widget");
    
      if (status === "true") {
        if (widgetExists) {
          showWidget();
        } else {
          load();
        }
      } else {
        removeWidget(); 
      }
    }
    
    checkLoginStatus();
    
    window.addEventListener("storage", (event) => {
      if (event.key === "loggedIn") {
        checkLoginStatus();
        console.log("Storage event detected, widget status checked");
        
      }
    });
    (function () {
      const originalSetItem = localStorage.setItem;
    
      localStorage.setItem = function (key, value) {
        originalSetItem.apply(this, arguments); // set value first
    
        if (key === "loggedIn" && value === "true") {
          console.log("🔐 LoggedIn set to true");
    
          const tryUntilReady = (retries = 0) => {
            const act = localStorage.getItem("act");
            const rft = localStorage.getItem("rft");
    
            if (act && rft) {
              console.log("✅ Tokens ready, calling refreshWidgetVisibility");
              if (typeof window.refreshWidgetVisibility === "function") {
                window.refreshWidgetVisibility();
              }
            } else {
              if (retries > 20) {
                console.warn("❌ Tokens not ready after retries");
                return;
              }
              setTimeout(() => tryUntilReady(retries + 1), 200);
            }
          };
    
          tryUntilReady();
        }
    
        if (key === "loggedIn" && value === "false") {
          console.log("🚪 Logged out, calling refreshWidgetVisibility");
          if (typeof window.refreshWidgetVisibility === "function") {
            window.refreshWidgetVisibility();
          }
        }
      };
    })();
    
    
    window.refreshWidgetVisibility = checkLoginStatus;
    
  } 
  
    